export default function ReferenceBar() {
  return (
    <div className="w-full bg-[#F5F1EA] border-t border-[#DDD5C4]/60 py-5 px-6">
      <p className="text-center text-[#8A7D6A] text-xs font-jost tracking-wide leading-relaxed">
        Featured in{' '}
        <a
          href="https://sites.google.com/view/bestcabinsnearglenfallshighlan"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="underline underline-offset-2 decoration-[#C9A96E]/60 text-[#7A6E5F] hover:text-[#5C4F3E] transition-colors cursor-pointer"
        >
          independent Highlands travel guides
        </a>
        .
      </p>
    </div>
  );
}